var version = {
    "name":      "dativery",
    "buildDateCode": "20260617-094347",
    "buildDate": "Wed Jun 17 2026 09:43:47 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260617-094347",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;